<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Transaksi Pembayaran</h5>
            </template>
            <div class="detail-data-wrapper">
                <h6 class="form-title">TRANSAKSI PEMBAYARAN BARU</h6>
                <b-table bordered hover show-empty 
                    :busy="isBusy" 
                    :items="daftarPembayaran"
                    :no-local-sorting="false" 
                    :fields="fields2"
                    @sort-changed="sortingChanged" 
                    responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data daftar pembayaran.
                    </template>
                    <template v-slot:cell(noKwitansi)="row">
                        <p class="mb-0">{{row.item.noKwitansi}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.noFaktur}}</p>
                    </template>
                    <template v-slot:cell(namaAnggota)="row">
                        <p class="mb-0">{{row.item.namaAnggota}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.noAnggota}}</p>
                    </template>
                    <template v-slot:cell(barang)="row">
                        <p class="mb-0">{{row.item.jenisBarang}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.merkBarang}} - {{row.item.tipeBarang}}</p>
                    </template>
                    <template v-slot:cell(jenis)="row">
                        <p class="mb-0" v-if="row.item.jenis == 'Perpanjangan + Cicilan Pokok'">Perpanjangan</p>
                        <p class="mb-0" v-else>{{row.item.jenis}}</p>
                    </template>
                    <template v-slot:cell(nominalPembayaran)="row">
                        <div class="text-right no-wrap">
                            <p class="mb-0" v-if="row.item.nominalPembayaran == null">{{$helper.addThousandSeparator(row.item.nominalPembayaran)}} </p>
                            <p class="mb-0" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalPembayaran)}} </p>
                        </div>
                        <div class="text-right no-wrap smallText text-muted">
                            <p class="mb-0" v-if="row.item.angsuranPokok == null">Angsuran{{$helper.addThousandSeparator(row.item.angsuranPokok)}} </p>
                            <p class="mb-0" v-else>Angsuran Rp. {{$helper.addThousandSeparator(row.item.angsuranPokok)}} </p>
                        </div>
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge variant="dark" v-if="row.item.status == 'Baru'">BARU</b-badge>
                        <b-badge variant="success" v-else-if="row.item.status == 'Terbayar'">TERBAYAR</b-badge>
                        <b-badge variant="danger" v-else-if="row.item.status == 'Void'">VOID</b-badge>
                        <b-badge variant="warning" v-else-if="row.item.status == 'Request Void'">REQUEST VOID</b-badge>
                        <b-badge v-else>{{ row.item.status }}</b-badge>   
                    </template>
                    <template v-slot:head(status)>
                        Status 
                        <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                    </template>
                    <template v-slot:cell(action)="row">
                        <div class="no-wrap">
                            <b-link :to="`${$route.path}/${row.item.id}`">
                                <b-button size="sm" class="mr-2" variant="pgiBtn" v-b-tooltip.hover title="Detail" name="daftarPembayaranViewBtn">
                                    <i class="fa fa-info"></i>
                                </b-button>
                            </b-link>
                        </div>
                    </template>
                </b-table>
            </div>
            <div class="detail-data-wrapper">
                <h6 class="form-title">HISTORY TRANSAKSI PEMBAYARAN HARI INI</h6>
                <div class="search-wrapper d-flex align-items-center justify-content-between">
                    <b-form-group
                        label="Filter"
                        label-for="filterInput"
                        class="form-inline form-group-wrapper mb-3"
                    >
                        <div class="d-flex search-input-wrapper">
                            <b-form-input class="ml-2 mr-2"
                                v-model="input.filterNoFaktur" name="filterNoFaktur"
                                id="filterInput"
                                type="search"
                                placeholder="Masukkan no. faktur"
                            ></b-form-input>
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy2" @click="onFilter"> 
                                <i class="fa fa-search"></i>
                            </b-button>
                            <b-button variant="pgiBtn" name="reseFilterBtn" :disabled="isBusy2" @click="onReset">Reset</b-button>
                        </div>
                    </b-form-group>
                </div>
                <b-table bordered hover show-empty 
                    :busy="isBusy2" 
                    :items="daftarPembayaranHistory"
                    :no-local-sorting="false" 
                    :fields="fields2"
                    @sort-changed="sortingChanged" 
                    responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data history transaksi pembayaran.
                    </template>
                    <template v-slot:cell(noKwitansi)="row">
                        <p class="mb-0">{{row.item.noKwitansi}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.noFaktur}}</p>
                    </template>
                    <template v-slot:cell(namaAnggota)="row">
                        <p class="mb-0">{{row.item.namaAnggota}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.noAnggota}}</p>
                    </template>
                    <template v-slot:cell(barang)="row">
                        <p class="mb-0">{{row.item.jenisBarang}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.merkBarang}} - {{row.item.tipeBarang}}</p>
                    </template>
                    <template v-slot:cell(jenis)="row">
                        <p class="mb-0" v-if="row.item.jenis == 'Perpanjangan + Cicilan Pokok'">Perpanjangan</p>
                        <p class="mb-0" v-else>{{row.item.jenis}}</p>
                    </template>
                    <template v-slot:cell(nominalPembayaran)="row">
                        <div class="text-right no-wrap">
                            <p class="mb-0" v-if="row.item.nominalPembayaran == null">{{$helper.addThousandSeparator(row.item.nominalPembayaran)}} </p>
                            <p class="mb-0" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalPembayaran)}} </p>
                        </div>
                        <div class="text-right no-wrap smallText text-muted">
                            <p class="mb-0" v-if="row.item.angsuranPokok == null">Angsuran{{$helper.addThousandSeparator(row.item.angsuranPokok)}} </p>
                            <p class="mb-0" v-else>Angsuran Rp. {{$helper.addThousandSeparator(row.item.angsuranPokok)}} </p>
                        </div>
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge variant="dark" v-if="row.item.status == 'Baru'">BARU</b-badge>
                        <b-badge variant="success" v-else-if="row.item.status == 'Terbayar'">TERBAYAR</b-badge>
                        <b-badge variant="danger" v-else-if="row.item.status == 'Void'">VOID</b-badge>
                        <b-badge variant="warning" v-else-if="row.item.status == 'Request Void'">REQUEST VOID</b-badge>
                        <b-badge v-else>{{ row.item.status }}</b-badge>   
                    </template>
                    <template v-slot:head(status)>
                        Status 
                        <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                    </template>
                    <template v-slot:cell(action)="row">
                        <div class="no-wrap">
                            <b-link :to="`${$route.path}/${row.item.id}`">
                                <b-button size="sm" class="mr-2" variant="pgiBtn" v-b-tooltip.hover title="Detail" name="daftarPembayaranHistoryViewBtn">
                                    <i class="fa fa-info"></i>
                                </b-button>
                            </b-link>

                            <b-button v-if="row.item.status == 'Terbayar' && row.item.jenis === 'Pelunasan' && IS_HAVE_PERMISSION_REQUEST_EDIT_TIPE_PELUNASAN" size="sm" class="mr-2" variant="warning" v-b-tooltip.hover title="Edit" name="daftarPembayaranHistoryEditBtn" @click="onShowModalEdit(row.item.id)">
                                <i class="fa fa-pencil-square-o text-white"></i>
                            </b-button>
                        </div>
                    </template>
                </b-table>
                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                        <b-form-select v-model="input.show" :options="options" @change="onLimitChange">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled />
                            </template>
                        </b-form-select>
                        <span class="ml-2">{{ totalViewText }}</span>
                    </b-input-group>
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        @input="onPageChange"
                        aria-controls="my-table"
                    ></b-pagination>
                </div>
            </div>
        </b-card>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">BARU</h6>
                <p class="smallText mb-0">Transaksi pembayaran yang baru diinput dan belum ditransaksikan. Seluruh pembayaran BARU yang tidak dieksekusi, akan dihapus keesokan harinya.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">TERBAYAR</h6>
                <p class="smallText mb-0">Transaksi pembayaran sudah dieksekusi (kwitansi sudah dicetak, kas cabang sudah berubah).</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">VOID</h6>
                <p class="smallText mb-0">Transaksi pembayaran sudah digugurkan (VOID).</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">REQUEST VOID</h6>
                <p class="smallText mb-0">Transaksi pembayaran sedang dalam proses VOID.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-upload-bukti" title="Upload Bukti" no-close-on-backdrop>
            No. Faktur : {{ activeFaktur }} 
            <div v-for="item of required" class="my-2" v-if="required.length != 0">
                {{ item.name }} <span v-if="item.isRequired" class="text-danger">*</span>
                <div class="d-flex">
                    <b-button class="mr-2" v-if="item.path != null" variant="cancelBtn" @click="viewFoto(item)">
                        Lihat Foto
                    </b-button>
                    <div class="browse-foto">
                        <b-form-file v-model="item.file" name="fotoBarangPendukung" :state="Boolean(item.file)"
                            drop-placeholder="Drop file here..." accept=".jpg, .png, .jpeg" @input="browseFile(item.type,item.file, (item.path != null) &&true ,item.id)">
                        </b-form-file>
                        <b-button variant="cancelBtn">
                            <i class="fa fa-upload"></i>
                        {{ (item.path != null) ?'Update Bukti' :'Upload'}}
                        </b-button>
                    </div>
                </div>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="pgiBtn" name="closePreviewBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-loading" centered size="sm" hide-footer hide-header no-close-on-esc no-close-on-backdrop>
            <h4 class="text-center text-lg">LOADING ...</h4>
        </b-modal>
        
        <b-modal id="modal-preview-foto" size="xl" :title="activeFotoPreview.name">
            <div>
                No. Faktur : {{ activeFaktur }}
            </div>
            <div class="my-2">
                Oleh : {{ activeFotoPreview.createdBy }} , {{ $helper.changeDateFormat(activeFotoPreview.createdAt) }} {{
                    $helper.changeDateFormatGetHour(activeFotoPreview.createdAt) }}
           </div>
            <div class="modal-foto-wrapper">
                <img :src="$baseFilePath + activeFotoPreview.path" alt="Foto">
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                    Close
                </b-button>
            </template>
        </b-modal>

        <ModalEditTipePelunasan
            :editState="editState"
            :formEdit="formEdit"
            @submit="onSubmitEdit"
        />
    </div>
</template>

<script>
import CONSTANTS from '@/constants'
import ModalEditTipePelunasan from '@/components/modals/ModalEditTipePelunasan.vue'

export default {
    name: 'transaksi-pembayaran',
    components: {
        ModalEditTipePelunasan,
    },
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            isBusy2: true,

            activeFaktur:'',
            activeFotoPreview: '',
            foto: [],

            sbgAwalGadai:[],
            sbgPelunasan:[],
            kwitansiPelunasan:[],
            notaHilang:[],

            input:{
                show: 10,
                sortDesc: null,
                sortBy: null,
                sortDesc: null,
                filter: null,
                filterNoFaktur: null,
                filterNoAnggota: null,
            },
            fields: [
                { key: "noKwitansi", label: "No. Kwitansi & Faktur" },
                { key: "namaAnggota", label: "Anggota" },
                { key: "barang", label: "Barang" },
                { key: "jenis", label: "Jenis Pembayaran" },
                { key: "nominalPembayaran", label: "Total Pembayaran" },
                { key: "status", label: "Status" },
                { key: "counterPrint", label: "# Print" },
                { key: "action", label: "Aksi" }
            ],
            fields2: [
                { key: "noKwitansi", label: "No. Kwitansi & Faktur" },
                { key: "namaAnggota", label: "Anggota" },
                { key: "barang", label: "Barang" },
                { key: "jenis", label: "Jenis Pembayaran" },
                { key: "nominalPembayaran", label: "Total Pembayaran" },
                { key: "status", label: "Status" },
                { key: "counterPrint", label: "# Print" },
                { key: "action", label: "Aksi" }
            ],
            daftarPembayaranHistory: [],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            srcCabangId: null,
            loading: false,
            query: "",
            query2: "",
            required: [],
            formEdit: {
                tipePelunasan: null,
                isLoading: false,
            },
            editState: {
                isLoading: false,
                isError: false,
                data: null,
            },
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.srcCabangId = this.$helper.getCabangId()
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(0, 100)
            this.query2 = this.$helper.makeQuery(this.page, this.size)

            let getDaftarPembayaran = this.$axios.get("gadai-pembayaran/"+this.query+"&cabangId="+this.srcCabangId+"&filterStatus=0").then(response => {
                this.daftarPembayaran= response.data.data
            }) 

            let getDaftarPembayaranHistory = this.$axios.get("gadai-pembayaran/"+this.query2+"&cabangId="+this.srcCabangId+"&filterStatus=-1").then(response => {
                this.daftarPembayaranHistory = response.data.data
                this.updateTotalItem(response.data.total)
            })

            Promise.all([getDaftarPembayaran, getDaftarPembayaranHistory]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
                this.toggleBusy2()

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //----------------- Fungsi Ambil Data Daftar Pembayaran  -----------------

        getDaftarPembayaranHistory(){
            this.toggleBusy2()
            this.daftarPembayaranHistory = []

            if (this.input.filterNoFaktur != null) this.query2 = this.query2 + "&filterNoFaktur=" + this.input.filterNoFaktur
            if (this.input.sortBy != null) this.query2 = this.query2 + "&sortBy=" + this.input.sortBy
            if (this.input.sortDesc != null) this.query2 = this.query2 + "&sortDesc=" + this.input.sortDesc
            
            this.$axios.get("gadai-pembayaran/"+this.query2+"&cabangId="+this.srcCabangId+"&filterStatus=-1").then(response => {
                this.daftarPembayaranHistory = response.data.data
                this.toggleBusy2()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy2()
                this.loading = false
            })
        },

        //----------------- Fungsi Pagination, Sorting, dan Filtering  -----------------

        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query2 = this.$helper.makeQuery(0, this.size)
            this.getDaftarPembayaranHistory()
        },

        onPageChange(){
            if (this.loading == false){
                this.page = this.currentPage - 1
                this.query2 = this.$helper.makeQuery(this.page, this.size)
                this.getDaftarPembayaranHistory()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset(){
            this.input.filterNoFaktur = null
            this.currentPage = 1
            this.page = 0
            this.query2 = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getDaftarPembayaranHistory()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query2 = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getDaftarPembayaranHistory()
        },

        uploadBukti(id,item){
            this.activeFaktur = item
            this.fetchSBG(item)
            this.$bvModal.show('modal-upload-bukti')
        },


        fetchSBG(faktur){
            this.$axios.get(`gadai-evidence/?noFaktur=${faktur}`)
            .then(response => {

                for(let item of response.data){
                    item.file = []
                }
                this.required = response.data            
            }).catch(error => {
                // Tindakan jika terjadi kesalahan
                console.log(error);
                this.initStatus = -1;
            }); 
        },


        browseFile(type, file , upload = false,id) {
            if (file == null) {
                return
            }

            this.$bvModal.show("modal-loading")
            let formData = new FormData();

            if(upload){
                formData.append('id', id);
                formData.append('file', file);
                
                this.$axios.post(`gadai-evidence/update/`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    this.$helper.toastSucc(this, "foto berhasil diUbah!")
                    this.fetchSBG(this.activeFaktur)
                    this.$bvModal.hide("modal-loading")
                }).catch(error => {
                    // Tindakan jika terjadi kesalahan
                    this.$helper.toastErr(this,error.response.data.reason)
                    this.$bvModal.hide("modal-loading")
                });
            } else {
                formData.append('noFaktur', this.activeFaktur);
                formData.append('type', type);
                formData.append('file', file);
                
                this.$axios.post(`gadai-evidence/insert`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    this.$helper.toastSucc(this, "foto berhasil diupload!")
                    this.fetchSBG(this.activeFaktur)
                    this.$bvModal.hide("modal-loading")
                }).catch(error => {
                    // Tindakan jika terjadi kesalahan
                    this.$helper.toastErr(this,error.response.data.reason)
                    this.$bvModal.hide("modal-loading")
                });
            }
        },

        viewFoto(item){
            this.activeFotoPreview = item
            this.$bvModal.show("modal-preview-foto")
        },


        //----------------- Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        toggleBusy2() {
            if(this.isBusy2 == true) this.isBusy2 = false
            else this.isBusy2 = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size

            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onShowModalEdit(id) {
            this.editState.isLoading = true
            this.editState.isError = false
            this.editState.data = null

            this.$bvModal.show("modal-edit")

            this.$axios.get(`gadai-pembayaran/${id}`)
                .then((response) => {
                    this.editState.data = response.data
                    this.formEdit.tipePelunasan = response.data.tipePelunasan
                })
                .catch((error) => {
                    this.editState.isError = true
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.editState.isLoading = false
                })
        },
        
        onSubmitEdit(form) {
            const id = this.editState.data.noFaktur;
            const type = form.tipePelunasan;
            this.formEdit.isLoading = true;

            this.$axios.put(`gadai-evidence/update-tipe/${id}?newTipe=${type}`)
                .then((response) => {
                    this.$helper.toastSucc(this, "Perubahan berhasil diajukan. Menunggu persetujuan.")
                    this.$bvModal.hide("modal-edit")
                })
                .catch((error) => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.$bvModal.hide("modal-confirm-edit-tipe-pelunasan")
                    this.formEdit.isLoading = false
                })
        }
    },
    computed: {
        IS_HAVE_PERMISSION_REQUEST_EDIT_TIPE_PELUNASAN() {
            const permissionRequestEditTipePelunasan = CONSTANTS.PERMISSION.EDIT_TIPE_PELUNASAN.REQUEST;
            return this.$helper.hasPermissionMenuChildren(permissionRequestEditTipePelunasan)
        }
    },
    created(){
        this.init()
    }
}
</script>
<style scoped>
.browse-foto{
    position: relative;
}

.browse-foto .custom-file{
    opacity: 0;
    z-index: 1;
}

.browse-foto .custom-file .custom-file-input{
    z-index: 0;
}

.browse-foto .custom-file .custom-file-label{
    cursor: pointer;
}

.browse-foto button{
    position: absolute;
    top: 0;
    left: 0;
}

.browse-foto{
    margin-right: 10px;
}

</style>
